import type { PointsOperation } from '../types';

interface OperationTableProps {
  operations: PointsOperation[];
  onReversal: (operation: PointsOperation) => void;
}

export default function OperationTable({ operations, onReversal }: OperationTableProps) {
  const getOperationTypeLabel = (type: string) => {
    return type === 'recharge' ? '充值' : '红冲';
  };

  const getOperationTypeColor = (type: string) => {
    return type === 'recharge' 
      ? 'bg-green-100 text-green-700' 
      : 'bg-red-100 text-red-700';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">交易流水号</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">操作类型</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">交易时间</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">租户名称</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">交易数量</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">操作人员</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">生效时间</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">过期时间</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">使用期限</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">原交易流水号</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">已扣减积分</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">可用积分</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">剩余积分</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">预消费积分</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">操作</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {operations.map((operation) => (
              <tr key={operation.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{operation.transactionNo}</td>
                <td className="px-4 py-3 text-sm whitespace-nowrap">
                  <span className={`px-2 py-1 text-xs rounded-full ${getOperationTypeColor(operation.operationType)}`}>
                    {getOperationTypeLabel(operation.operationType)}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">{operation.transactionTime}</td>
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{operation.tenantName}</td>
                <td className="px-4 py-3 text-sm whitespace-nowrap">
                  <span className={operation.transactionAmount > 0 ? 'text-green-600 font-medium' : 'text-red-600 font-medium'}>
                    {operation.transactionAmount > 0 ? '+' : ''}{operation.transactionAmount.toLocaleString()}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{operation.operator}</td>
                <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">{operation.effectiveTime}</td>
                <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">{operation.expiryTime}</td>
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{operation.usagePeriod} 天</td>
                <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">{operation.originalTransactionNo}</td>
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{operation.deductedPoints.toLocaleString()}</td>
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{operation.availablePoints.toLocaleString()}</td>
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{operation.remainingPoints.toLocaleString()}</td>
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{operation.preConsumedPoints.toLocaleString()}</td>
                <td className="px-4 py-3 text-sm whitespace-nowrap">
                  {operation.operationType === 'recharge' && (
                    <button
                      onClick={() => onReversal(operation)}
                      className="text-red-600 hover:text-red-700 font-medium"
                    >
                      红冲
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
